import ManagingBrandAssets from "../../../../src/pages/use-cases/page-content/content-publishing/managing-brand-assets.md";
import * as React from 'react';
export default {
  ManagingBrandAssets,
  React
};